export const GetCardPromotionGroupsRejectCase = {
    /** 카드프로모션 사용 불가 pageSet */
    CARD_PROMOTION_UNAPPLICABLE_PAGE_SET: 'CARD_PROMOTION_UNAPPLICABLE_PAGE_SET',
} as const

export type GetCardPromotionGroupsRejectCaseValues = Constant<typeof GetCardPromotionGroupsRejectCase>
